import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CardSpinner } from "../components/CardSpinner";
import { Footer } from "../components/Footer";
import { useAuth } from "../context/AuthContext";

type Status = "pending" | "error";

export function LoginConsumePage() {
  const { consumeMagicLink } = useAuth();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<Status>("pending");
  const [message, setMessage] = useState("Validation du lien magique...");
  const consumedRef = useRef(false);

  useEffect(() => {
    if (consumedRef.current) return;
    consumedRef.current = true;

    const token = params.get("token");

    if (!token) {
      setStatus("error");
      setMessage("Lien invalide : aucun token trouvé.");
      return;
    }

    void consumeMagicLink(token)
      .then((user) => {
        navigate(user.hasCompletedProfile ? "/home" : "/profile", {
          replace: true,
        });
      })
      .catch((error) => {
        setStatus("error");
        setMessage(
          error instanceof Error
            ? error.message
            : "Impossible d'ouvrir la session.",
        );
      });
  }, [consumeMagicLink, navigate, params]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4 py-10">
      <div className="flex flex-1 flex-col items-center justify-center">
        <div className="card w-full max-w-md text-center">
          {status === "pending" ? (
            <div className="flex flex-col items-center gap-4">
              <CardSpinner className="h-12 w-12" color="#d1d5db" />
              <p className="text-sm text-smoke">{message}</p>
            </div>
          ) : (
            <>
              <h1 className="text-2xl font-bold text-ink">
                Connexion en cours
              </h1>
              <p className="mt-4 rounded-xl bg-rose-50 px-4 py-3 text-sm text-rose-700">
                {message}
              </p>
            </>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
